import { Dispatch } from 'redux';
import { SPRITE_LOADER_PROGRESS } from 'actiontypes/spriteLoader';

export function spriteLoaderProgress(progress: number) {
  return (dispatch: Dispatch) => dispatch({ type: SPRITE_LOADER_PROGRESS, payload: progress });
}